import { TemplateRef } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { CALENDAR_LOCALE } from '../../services/constant';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
var DocumentRequestComponent = (function () {
    function DocumentRequestComponent(apiService, modalService, translateService, router) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.translateService = translateService;
        this.router = router;
        this.abbNo = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.confirmationNo = null;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.loading = false;
        this.requestNo = null;
        this.roomChoices = [];
        this.selectedRoomType = null;
        this.selectedStatus = null;
        this.statusChoices = [];
        this.tableData = [];
        if (!environment.enabledCustomerRequest) {
            this.router.navigate(['/login']);
        }
    }
    DocumentRequestComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translateService.onLangChange.subscribe(function () {
            _this.loadDropdown();
        });
        this.loadDropdown();
        this.loadInitialData();
        this.search();
    };
    Object.defineProperty(DocumentRequestComponent.prototype, "currentLang", {
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    DocumentRequestComponent.prototype.loadDropdown = function () {
        this.roomChoices = [
            { label: this.translateService.instant('COMMON.ALL'), value: null },
            { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.HOTEL'), value: 'hotel' },
            { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.DINNING'), value: 'dinning' },
        ];
        this.statusChoices = [
            { label: this.translateService.instant('COMMON.ALL'), value: null },
            { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.PENDING'), value: 'pending' },
            { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.DONE'), value: 'done' },
            { label: this.translateService.instant('DOCUMENT-REQUEST.FILTER.CANCELLED'), value: 'cancelled' },
        ];
        this.calendarLocale = this.translateService.currentLang === 'en'
            ? CALENDAR_LOCALE.EN
            : CALENDAR_LOCALE.TH;
        this.search();
    };
    DocumentRequestComponent.prototype.loadInitialData = function () {
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    DocumentRequestComponent.prototype.getFilterParams = function () {
        return {
            page: this.currentPage,
            page_size: this.itemsPerPage,
            status: this.selectedStatus || '',
            room_type: this.selectedRoomType || '',
            request_no: this.requestNo || '',
            abb_no: this.abbNo || '',
            confirmation_no: this.confirmationNo || '',
            created_at_after: moment(this.startDate).format('YYYY-MM-DD'),
            created_at_before: moment(this.endDate).format('YYYY-MM-DD'),
        };
    };
    DocumentRequestComponent.prototype.search = function () {
        var _this = this;
        this.loading = true;
        var payload = this.getFilterParams();
        this.apiService.getDocumentRequest(payload).subscribe(function (res) {
            _this.tableData = res.results;
            _this.totalItems = res.count;
            _this.loading = false;
        }, function (err) {
            _this.loading = false;
            console.error(err);
        });
    };
    Object.defineProperty(DocumentRequestComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    DocumentRequestComponent.prototype.openDocumentRequestDetail = function (modalContent, id) {
        var _this = this;
        this.apiService.getDocumentResponseDetail(id).subscribe(function (result) {
            _this.documentRequest = result;
            _this.modal = _this.modalService.open(modalContent, { size: 'lg', centered: true, windowClass: 'custom-modal' });
        }, function (error) {
            console.error(error);
        });
    };
    DocumentRequestComponent.prototype.openConfirmationModal = function (modalContent, id, action) {
        this.stateAction = action;
        switch (action) {
            case 'cancel': {
                this.confirmMsg = this.translateService.instant('DOCUMENT-REQUEST.CANCEL-CONFIRM');
                break;
            }
            case 'delete': {
                this.confirmMsg = this.translateService.instant('DOCUMENT-REQUEST.DELETE-CONFIRM');
                break;
            }
            case 'restore': {
                this.confirmMsg = this.translateService.instant('DOCUMENT-REQUEST.RESTORE-CONFIRM');
                break;
            }
            default: {
                return;
            }
        }
        this.selectedDocumentRequest = id;
        this.modal = this.modalService.open(modalContent, { centered: true });
    };
    DocumentRequestComponent.prototype.confirmAction = function () {
        var _this = this;
        var request$ = null;
        switch (this.stateAction) {
            case 'cancel': {
                request$ = this.apiService.cancelDocumentRequest(this.selectedDocumentRequest);
                break;
            }
            case 'delete': {
                request$ = this.apiService.deleteDocumentRequest(this.selectedDocumentRequest);
                break;
            }
            case 'restore': {
                request$ = this.apiService.restoreDocumentRequest(this.selectedDocumentRequest);
                break;
            }
            default: {
                return;
            }
        }
        if (!request$) {
            return;
        }
        request$.subscribe(function () {
            _this.closeModal();
            _this.modal = _this.modalService.open(_this.successContent, { centered: true });
        }, function (error) {
            console.error(error);
        });
    };
    DocumentRequestComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    DocumentRequestComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    Object.defineProperty(DocumentRequestComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    DocumentRequestComponent.prototype.clear = function () {
        this.selectedRoomType = null;
        this.selectedStatus = null;
        this.selectedDocumentRequest = null;
        this.requestNo = null;
        this.documentRequest = null;
        this.stateAction = null;
        this.loadInitialData();
        this.optionChange();
    };
    DocumentRequestComponent.prototype.pageChanged = function () {
        this.search();
    };
    DocumentRequestComponent.prototype.optionChange = function () {
        this.currentPage = 1;
        this.search();
    };
    DocumentRequestComponent.prototype.closeModal = function (refresh) {
        if (this.modal) {
            this.modal.close();
        }
        if (refresh) {
            this.search();
        }
    };
    return DocumentRequestComponent;
}());
export { DocumentRequestComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-request/document-request.component.ts.pre-build-optimizer.js